import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { ErrorTextService } from 'src/app/services/error-text.service';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-aircraft',
  templateUrl: './aircraft.component.html',
  styleUrls: ['./aircraft.component.scss']
})
export class AircraftComponent implements OnInit {
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  token = window.sessionStorage.getItem('token');
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  userBase;
  selectedBase;
  aircraft = [];
  userIsSysAdmin = false;
  bases = [];  
  headings = [
    {
      label: 'Callsign',
      key: 'callsign'
    },
    {
      label: 'Make/Model',
      key: 'Aircraft_Name'
    },
    {
      label: 'Tail Number',
      key: 'Aircraft_Tail_Number'
    },
    {
      label: 'Operator',
      key: 'Aircraft_Owner'
    },
    {
      label: 'Active',
      key: 'active'
    }
  ];
  settings = {
    label: 'Aircraft',
    action: 'create',
    target: 'aircraft',
    route: 'aircraft'
  };

  constructor(
    private toast: ToastService,
    private errorTextService: ErrorTextService
  ) {}

  async ngOnInit() {
    if (this.userInfo.role == 'sysadmin') {
      this.userIsSysAdmin = true;
    }

    axios
    .get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    })
    .then((response) => {
      this.bases = response.data;

      this.bases.forEach((base) => {
        base.name = base.text + ' | ' + base.baseCode;
        base.value = base.baseId;

        if (base.baseCode === this.userInfo.baseCode) {
          this.selectedBase = base;
        }
      });

      this.refreshAircraft();

    })
    .catch((error) => {
      console.dir(error);
    });

    this.refreshAircraft();
  }

  selectHomeBase(selectedBase) {
    this.selectedBase = selectedBase;
    this.refreshAircraft();
  }

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.delete(data.aircraft);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDelete = (aircraft) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this aircraft?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        aircraft: aircraft
      },
      active: true
    };
  };

  delete = async (aircraft) => {
    this.loading = true;
    let userId = this.userInfo.id;
    this.userBase = this.userInfo.basecode;
    let id = '';
    if (aircraft.id) {
      id = aircraft.id;
    } else if (aircraft.href) {
      id = aircraft.href.slice(
        aircraft.href.indexOf('/travelmodes/') + '/travelmodes/'.length,
        aircraft.href.length
      );
    }
    axios
      .delete(
        environment.API_URL + '/travelmodes/' + id + '/delete?userId=' + userId,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show('Deleted Aircraft', 'success');
        this.refreshAircraft();
      })
      .catch((error) => {
        this.loading = false;
        this.toast.showFullError('Unable to Delete Aircraft', error);
      });
  };

  refreshAircraft = () => {
    let baseCode = this.selectedBase.baseCode;

    this.loading = true;

    axios
      .get(environment.API_URL + '/travelmodes?baseCode=' + baseCode, {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        this.aircraft = response.data.value;
        this.aircraft.forEach((aircraft) => {
          aircraft.active = aircraft.deleted ? 'No' : 'Yes';
        });
        this.loading = false;
      })
      .catch((error) => {
        this.toast.showFullError('Unable to retreive Aircraft.', error);
        this.loading = false;
      });
  };
}
